import { fetch, jsmErrorTransformer } from '@atlassian/eoc-fetch';

import { type UserResourceType } from '../../../common/utils/types';

const JSM_BASE_URL = '/rest/api/3/myself';

export const fetchJsmUserInfo = (): Promise<UserResourceType> => {
	return fetch<UserResourceType>(JSM_BASE_URL, {
		exactUrl: true,
		errorTransformer: jsmErrorTransformer,
	});
};
